import React, { useEffect, useState } from 'react';
import { GraphProvider, useGraphContext } from './graphUtils/graphContext';
import { initSVG, updateData, initZoom, addDragBehaviour, updateColorsForExpandButtons } from "./graphUtils/graphSetup";
import { setupSimulation } from "./graphUtils/graphSimulation";
import { getLinks, panToNodeSmooth } from "./graphUtils/graphUtility";

function Graph({ graphData,setCurrentSelectedNode, onExpandNode, width, height, onReload, setOnReload, panToNode, setPanToNode, currentlyExpandingNodes, recenterNode }) {
    
    const [dataToShow, setDataToShow] = useState(null);
    const context = useGraphContext();
    const ref = React.useRef(null);

    useEffect(() => {
        if (!graphData) return;
        if (!graphData.nodes) return;
        if (graphData.nodes.length === dataToShow?.nodes.length) return;
        
        var dataToUpdate = graphData.nodes.filter(n => n.isVisible !== false);
        if (dataToUpdate.length === dataToShow?.nodes.length) return;

        setDataToShow({ nodes: dataToUpdate });
    }, [graphData]);

    useEffect(() => {
        if (!recenterNode) return;
        if (!dataToShow) return;
        if (!dataToShow.nodes) return;
        const node = dataToShow.nodes.find(n => n.id === recenterNode);
        if (!node) return;
        panToNodeSmooth(node, context.svg, context.zoom, 0.6);
    }, [recenterNode]);

    useEffect(() => {
        if (!dataToShow) return;
        init();
        if (panToNode) {
            panToNodeSmooth(panToNode, context.svg, context.zoom, 0.4);
            setPanToNode(null);
        }
    }, [dataToShow]);

    useEffect(() => {
        if (!dataToShow) return;
        if (!currentlyExpandingNodes) return;
        if (!dataToShow.nodes) return;

        const nodes = dataToShow.nodes.filter(n => n.isVisible !== false);
        
        if (!nodes) return;
        if (nodes.length === 0) return;

        updateColorsForExpandButtons(currentlyExpandingNodes,nodes, onExpandNode, context);
    }, [currentlyExpandingNodes]);

    useEffect(() => {
        if (!onReload) return;
        if (!dataToShow) return;
        const { svg, zoom, currentNode } = context;

        currentNode.current = null;
        const mainNode = dataToShow.nodes.find(n => n.group === 0);
        panToNodeSmooth(mainNode, svg, zoom, 0.6);
        setOnReload(false);
    }, [onReload]);

    function init() {
        const nodes = dataToShow.nodes.filter(n => n.isVisible !== false);
        const links = getLinks(nodes);

        initSVG(width, height, ref, context);
        setupSimulation(nodes, links, context);
        updateData(nodes, links, onExpandNode, setCurrentSelectedNode, context);
        addDragBehaviour(context);
        initZoom(context);
    }

    return (
        <div className="Graph" ref={ref} />
    );
}

export default function GraphWithProvider(props) {
    return (
        <GraphProvider>
            <Graph {...props} />
        </GraphProvider>
    );
}
